export enum EmailTemplates {
    RenewPassword = "template_m16neqc",
    OrderConfirmation = "template_zp8txng"
}